// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './SegmentedControl';



// WEBPACK FOOTER //
// ./components/SegmentedControl/index.js